import { render, staticRenderFns } from "./DeleList.vue?vue&type=template&id=53f8bbbf&scoped=true&"
import script from "./DeleList.vue?vue&type=script&lang=js&"
export * from "./DeleList.vue?vue&type=script&lang=js&"
import style0 from "./DeleList.vue?vue&type=style&index=0&id=53f8bbbf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f8bbbf",
  null
  
)

export default component.exports